// extracted by mini-css-extract-plugin
module.exports = {"selectedUser":"selectOrder_selectedUser__2Fvb7","selectedUserName":"selectOrder_selectedUserName__3CNKM","avatar":"selectOrder_avatar__3CU5K"};